import { useEffect } from 'react';
import { Formik, FormikProps } from 'formik';
import { IProductFormValues, productValidationSchema } from '../../../../common/validations/product.validations';
import { getProductFormInitialValues } from './initial-values';
import ProductDetails from './product-details';
import PeriodDetails from './period-details';
import TotalSection from './total-section';
import styles from './index.module.scss';

interface ProductFormWrapperProps {
  onSubmit: (values: IProductFormValues) => void | Promise<void>;
  initialValues?: IProductFormValues;
  innerRef?: React.Ref<FormikProps<IProductFormValues>>;
  onFormStateChange?: (values: IProductFormValues, isValid: boolean) => void;
}

const ProductFormWrapper = ({ onSubmit, initialValues, innerRef, onFormStateChange }: ProductFormWrapperProps) => {
  return (
    <Formik
      innerRef={innerRef}
      initialValues={initialValues || getProductFormInitialValues()}
      validationSchema={productValidationSchema}
      onSubmit={onSubmit}
      enableReinitialize={!!initialValues}
      validateOnMount
    >
      {(formikProps) => {
        return (
          <FormStateTracker 
            values={formikProps.values} 
            isValid={formikProps.isValid}
            onFormStateChange={onFormStateChange}
          >
            <div className={styles.body}>
              <h4 className='f-12 line-height-18 f-400 f-grey m-0'>Product Details</h4>
              <ProductDetails {...formikProps} />
              <div className="divider" />
              <PeriodDetails {...formikProps} />
              <div className="divider" />
              <TotalSection {...formikProps} />
            </div>
          </FormStateTracker>
        );
      }}
    </Formik>
  );
};

interface FormStateTrackerProps {
  values: IProductFormValues;
  isValid: boolean;
  onFormStateChange?: (values: IProductFormValues, isValid: boolean) => void;
  children: React.ReactNode;
}

const FormStateTracker = ({ values, isValid, onFormStateChange, children }: FormStateTrackerProps) => {
  useEffect(() => {
    if (onFormStateChange) {
      onFormStateChange(values, isValid);
    }
  }, [values, isValid, onFormStateChange]);

  return <>{children}</>;
};

export default ProductFormWrapper;

